import React, { useState, useEffect } from 'react';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import Database from './Database';
import M from 'materialize-css';
import { storage } from '../../config/fbConfig';

function DatabaseList(props) {
  const [selectedDatabaseId, setSelectedDatabaseId] = useState('');
  const [selectedDatabase, setSelectedDatabase] = useState('');
  const { databases, firestore } = props;
  const refModal = React.createRef();

  const initLoading = () => {
    let elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  };

  useEffect(initLoading, []);

  const deleteSelectedDatabase = () => {
    storage
      .ref('/databases')
      .child(selectedDatabase.databaseName)
      .delete()
      .then(() => {
        deleteFromFirestore();
      })
      .catch((error) => {
        console.log('Error deleting file from storage', error);
      });
  };

  const deleteFromFirestore = () => {
    firestore
      .collection('databases')
      .doc(selectedDatabaseId)
      .delete()
      .then(() => {
        M.toast({ html: 'Database deleted' });
        return true;
      })
      .catch((error) => {
        console.log('Delete database Failed', error);
        return false;
      });
  };

  const renderDeleteDialog = () => {
    return (
      <div ref={refModal} id="modal1" className="modal">
        <div className="modal-content">
          <h5>Are you sure to delete "{selectedDatabase.alias}" Database?</h5>
          <p>This action will remove ALL the data related to this Database</p>
        </div>
        <div className="modal-footer">
          <a href="#!" onClick={(e) => deleteSelectedDatabase()} className="modal-close waves-effect btn btn-flat">
            Confirm
          </a>
          <a href="#close" className="modal-close waves-effect btn btn-flat">
            Cancel
          </a>
        </div>
      </div>
    );
  };

  const onDelete = (id, element) => {
    const modal = M.Modal.getInstance(refModal.current);
    setSelectedDatabaseId(id);
    setSelectedDatabase(element);
    modal.open();
  };

  return (
    <div className="company-list section">
      <div className="title-section">Databases</div>

      {renderDeleteDialog()}

      {databases.map((database, index) => {
        return <Database key={database.id} database={database} onDelete={onDelete} />;
      })}
    </div>
  );
}

export default compose(firestoreConnect())(DatabaseList);
